module.exports = __webpack_public_path__ + "img/warning.e703fe1c.svg";